import { FETCH_WORKKARD_FILES_REQUEST_SUCCESS,RESET_WORKKARD_FILES_REQUEST_SUCCESS } from "../actions/actionConstants";
import { take } from 'redux-saga/effects';

const initialState = {
    skip: 0,
    take: 20,
    sortBy:1,
    rows:20,
    filterOption:['all'],
    data:{
      Total : 0,
      Data:[]
    }

};


export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_WORKKARD_FILES_REQUEST_SUCCESS: {
      const workkardFilesdata =  {
            skip: action.payload.skip,
            take: action.payload.take,
            sortBy: action.payload.sortBy,
            rows: action.payload.rows,
            filterOption: action.payload.filterOption,
            data: {
              Total : action.payload.data.Total,
              Data : [...state.data.Data,...action.payload.data.Data]
            }
      }
      return Object.assign (
            {},
            state,
            workkardFilesdata
      )
    }

    case RESET_WORKKARD_FILES_REQUEST_SUCCESS:{
      return Object.assign (
        {},
        state,
        initialState
    )
    }

    default:
      return state;
  }
}
